export const env = {
  apiBaseUrl:
    import.meta.env.VITE_LEX_API_URL ?? 'https://api.lexsuite.app/api/v1',
  dataroomBaseUrl:
    import.meta.env.VITE_LEX_DATAROOM_URL ?? 'https://dataroom.lexsuite.app',
  cognitoDomain:
    import.meta.env.VITE_COGNITO_DOMAIN ?? 'https://auth.lexsuite.app',
  cognitoClientId:
    import.meta.env.VITE_COGNITO_CLIENT_ID ?? '2se8ch2r6ve5u4b3dagk667428',
  redirectUri:
    import.meta.env.VITE_REDIRECT_URI ??
    'https://addin.lexsuite.app/auth/callback.html',
  scope: 'openid profile email',
};
